import { MouseEvent } from 'react';
import { CTATypes, EntityTypes } from '../../../../../new-lib/constants/common';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { theme } from '../../../../../styles/theme';
import { useRouter } from 'next/router';
import { handleCardContactEvent } from '../../../../../helpers/cards';
import { getPhoneNumber } from '../../../../../helpers/common';
import { phoneHelper } from '../../../../../helpers/phone-helper';
import { trackEvent } from '../../../../../new-lib/remarketing';
import CallIcon from '../../../../../new-components/svg-icons/CallIcon';
import ButtonIcon from '../../../../../new-components/ui/ButtonIcon';
import WhatsappIcon from '../../../../../new-components/svg-icons/WhatsappIcon';
import WhatsappCityScapeOffers from '../../../../../helpers/whatsapp/whatsapp-cityscape-offer';
import { CompoundOffer } from '../../../dtos';
import ButtonTextIcon from '../../../../../new-components/ui/ButtonTextIcon';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

interface CardCTAProps {
  offer: CompoundOffer;
  entityType?: EntityTypes;
  clickEventData?: any;
  closeModal?: boolean;
}

const OffersCTA = ({
  offer,
  entityType,
  clickEventData,
  closeModal
}: CardCTAProps) => {
  let { asPath } = useRouter();
  const { t } = useTranslation('common');
  const referer = useSelector((state: any) => state.app.referer);
  const userId = useSelector((state: any) => state.app.userId);
  const eventId = useSelector((state: any) => state.app.eventId);
  const PHONE_NUMBER = getPhoneNumber(referer);
  const whatsapp = new WhatsappCityScapeOffers(
    offer,
    asPath,
    referer,
    userId,
    eventId,
    CTATypes.CITYSCAPE_COMPOUND
  );

  const handleWhatsAppClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    whatsapp.launchWhatsApp();
    handleCardContactEvent({
      ...clickEventData,
      eventAction: 'whatsapp',
      eventId: eventId,
      compound: offer,
      entityType: EntityTypes.COMPOUND
    });
    trackEvent.purchase({
      listingIds: [offer.id]
    });
  };
  const handlePhoneCall = (e: MouseEvent) => {
    e.stopPropagation();
    phoneHelper(offer, asPath, Number(PHONE_NUMBER), entityType as any);
    handleCardContactEvent({
      ...clickEventData,
      eventAction: 'call',
      eventId: eventId,
      entityType: entityType
    });
    trackEvent.purchase({
      listingIds: [offer.id]
    });
  };

  const router = useRouter();

  if (closeModal) {
    return (
      <Container>
        <ButtonIcon
          backgroundColor="#E4EBF2"
          color={theme.light.colors.primaryBlue}
          border="none"
          icon={<CallIcon />}
          onClick={e => {
            e.preventDefault();
            handlePhoneCall(e);
            router.push(`tel:+2${PHONE_NUMBER}`);
          }}
          data-test={`call-${PHONE_NUMBER}`}
        />

        <ButtonIcon
          backgroundColor="#4CD964"
          color={theme.light.colors.white}
          border="none"
          icon={<WhatsappIcon />}
          onClick={(event: any) => handleWhatsAppClick(event)}
          dataTest={`whatsapp-btn`}
        />
      </Container>
    );
  }

  return (
    <div
      className="btns-container"
      itemScope
      itemType="https://schema.org/Action"
    >
      <Link href={`tel:+2${PHONE_NUMBER}`} itemProp="url">
        <ButtonTextIcon
          backgroundColor="#E4EBF2"
          backgroundHover="#D4DBE2"
          color="#1E4164"
          fontSize="14px"
          padding="8px 16px"
          border="none"
          text={t('call_us')}
          icon={<CallIcon />}
          onClick={e => handlePhoneCall(e)}
        />
      </Link>

      {entityType != EntityTypes.AREA &&
        entityType != EntityTypes.DEVELOPER && (
          <ButtonTextIcon
            backgroundColor="#4CD964"
            backgroundHover=" #40B855"
            color="white"
            fontSize="14px"
            icon={<WhatsappIcon />}
            padding="8px 16px"
            text={t('whatsapp')}
            border="none"
            onClick={e => handleWhatsAppClick(e)}
          />
        )}
    </div>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;

  button {
    width: 36px;
    height: 36px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
export default OffersCTA;
